import { render, staticRenderFns } from "./WarehouseDetail.html?vue&type=template&id=354d6dea&external"
import script from "./WarehouseDetail.ts?vue&type=script&lang=ts&external"
export * from "./WarehouseDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./WarehouseDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports